// Kurzinfos unter dem Objekttitel: feste Keys + "amenity:<id>" für Kurzinfo-Merkmale. Reihenfolge/Sichtbarkeit aus settings.property_facts
export const BASE_FACTS = [
  { key: "guests", label: "Gäste" }, { key: "bedrooms", label: "Schlafzimmer" }, { key: "bathrooms", label: "Bäder" },
  { key: "size", label: "Gesamtgröße (m²)" }, { key: "type", label: "Objekttyp (Ferienhaus, Ferienwohnung …)" }, { key: "weather", label: "Live-Wetter am Ort (neben dem Ortsnamen)" },
];

// Ergibt geordnete Liste [{key, on, label, amenity?}] – gespeicherte Konfiguration + neue Einträge (standardmäßig an) hinten
export const resolveFacts = (saved, catalogItems = []) => {
  const all = [...BASE_FACTS.map((f) => ({ ...f })), ...catalogItems.filter((a) => a.highlight).map((a) => ({ key: `amenity:${a.id}`, label: a.label.de, amenity: a }))];
  const byKey = Object.fromEntries(all.map((f) => [f.key, f]));
  const out = (saved || []).filter((s) => byKey[s.key]).map((s) => ({ ...byKey[s.key], on: s.on !== false }));
  const seen = new Set(out.map((f) => f.key));
  all.forEach((f) => { if (!seen.has(f.key)) out.push({ ...f, on: true }); });
  return out;
};
